import { Button, Input } from "components"
import { t } from "i18next"
import { Box } from "theme-ui"
export const Identity = () => {
 return (
  <div className="w-[96%] mx-auto mt-6">
   <h1 className="Jakarta-font font-semibold pb-3">{t("changeIdentity")}</h1>
   <Box bg="highlight" className="Jakarta-font py-5 px-4 rounded">
    <h1 className="font-semibold">{t("user")}</h1>
    <div className="flex gap-2 lg:flex-wrap lg:flex-row flex-col py-4 w-full">
     <div className="flex flex-col lg:justify-center lg:w-[24%] w-full">
      <label className="text-sm font-semi" htmlFor="Vorname">
       {t("firstName")}:
      </label>
      <Input
       id="Vorname"
       className="bg-gray py-2 outline-none rounded px-2 text-black w-full"
       type="text"
       placeholder="Name"
      />
     </div>
     <div className="flex flex-col lg:justify-center lg:w-[24%] w-full">
      <label className="text-sm font-semi" htmlFor="Nachname">
       {t("lastName")}:
      </label>
      <Input
       id="Nachname"
       className="bg-gray py-2 outline-none rounded px-2 text-black w-full"
       type="text"
       placeholder="Nachname"
      />
     </div>
     <div className="flex flex-col lg:justify-center lg:w-[24%] w-full">
      <label className="text-sm font-semi" htmlFor="eMail">
       {t("eMail")}:
      </label>
      <Input
       id="eMail"
       className="bg-gray py-2 outline-none rounded px-2 text-black w-full"
       type="email"
       placeholder="eMail:"
      />
     </div>
     <div className="flex flex-col lg:justify-center lg:w-[24%] w-full">
      <label className="text-sm font-semi" htmlFor="Telefon">
       {`${t("phoneNumber")}.:`}
      </label>
      <Input
       id="Telefon"
       className="bg-gray py-2 outline-none rounded px-2 text-black w-full"
       type="text"
       placeholder="Enter here...."
      />
     </div>
     <div className="flex flex-col lg:justify-center lg:w-[24%] w-full">
      <label className="text-sm font-semi" htmlFor="Mobil">
       {`${"mobileNo"}.:`}
      </label>
      <Input
       id="Mobil"
       className="bg-gray py-2 outline-none rounded px-2 text-black w-full"
       type="text"
       placeholder="Enter here...."
      />
     </div>
     <div className="flex flex-col lg:justify-center lg:w-[24%] w-full">
      <label className="text-sm font-semi" htmlFor="Author">
       {`${"authorizationNotification"}:`}
      </label>
      <Input
       id="Author"
       className="bg-gray py-2 outline-none rounded px-2 text-black w-full"
       type="email"
       placeholder="email"
      />
     </div>
    </div>
    <div className="flex justify-end">
     <div className="mr-2">
      <Button size={"xl"} color={"darkGray"}>
       {t("cancel")}
      </Button>
     </div>

     <div>
      <Button size={"xl"}>{t("save")}</Button>
     </div>
    </div>
   </Box>
  </div>
 )
}
